import { render, staticRenderFns } from "./GiftCardTicketBoxUsed.vue?vue&type=template&id=50b8ffd0&"
import script from "./GiftCardTicketBoxUsed.vue?vue&type=script&lang=js&"
export * from "./GiftCardTicketBoxUsed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports